import React, { useState } from 'react';
import { Form, Input, Button, Typography, Alert } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import AuthCard from '../../components/AuthCard';
import zeroLogo from '../../assets/images/zero-logo-small.png';

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const from = location.state?.from?.pathname || '/';

  const onFinish = async ({ email, password }) => {
    setLoading(true);
    setError(null);
    try {
      await login(email, password);
      navigate(from, { replace: true });
    } catch (err) {
      setError(err.response?.data?.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthCard foot={<a href="/forgot-password">Forgot password?</a>}>
      <div style={{ textAlign: 'center', marginBottom: 28 }}>
        <img src={zeroLogo} alt="Agent Zero" style={{ width: 48, height: 48, objectFit: 'contain' }} />
        <Typography.Title
          level={3}
          style={{
            marginTop: 14,
            marginBottom: 0,
            fontWeight: 700,
            background: 'linear-gradient(135deg, #0b1426 0%, #1a2332 50%, #2c3e50 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text'
          }}
        >
          Agent Zero
        </Typography.Title>
        <Typography.Text type="secondary" style={{ letterSpacing: '0.08em' }}>
          PROPERTY PORTAL
        </Typography.Text>
      </div>
      {error && <Alert type="error" message={error} style={{ marginBottom: 16 }} showIcon />}
      <Form layout="vertical" onFinish={onFinish} requiredMark={false}>
        <Form.Item name="email" label="Email" rules={[{ required: true, type: 'email' }]}>
          <Input size="large" placeholder="you@company.com" autoComplete="username" />
        </Form.Item>
        <Form.Item name="password" label="Password" rules={[{ required: true }]}>
          <Input.Password size="large" placeholder="••••••••" autoComplete="current-password" />
        </Form.Item>
        <Button type="primary" htmlType="submit" size="large" block loading={loading}>
          Sign in
        </Button>
      </Form>
    </AuthCard>
  );
}
